<template>
  <StepLayout
    v-if="isExperimentValid && isMarketEligible && isSmartphones"
    ref="root"
    class="mb-48 py-32 md:py-36"
  >
    <template #left>
      <StepIllustration
        position="center_center"
        src="/img/mobile-plan/step-mobile-plan-square.png"
      />
    </template>

    <template #right>
      <BackMarketMobilePlan v-if="shouldDisplayBackMarketMobilePlan" />
      <ExternalTelcoMobilePlan v-else />
    </template>
  </StepLayout>
</template>

<script setup lang="ts">
import { computed, onUnmounted, ref } from 'vue'

import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { useIntersectionObserver } from '@vueuse/core'

import StepIllustration from '../StepIllustration/StepIllustration.vue'
import StepLayout from '../StepLayout/StepLayout.vue'

import BackMarketMobilePlan from './components/BackMarketMobilePlan/BackMarketMobilePlan.vue'
import ExternalTelcoMobilePlan from './components/ExternalTelcoMobilePlan/ExternalTelcoMobilePlan.vue'

const experiments = useExperiments()
const tracking = useTracking()
const {
  market: { countryCode },
} = useMarketplace()
const props = defineProps<{
  trackingModel: string
  categoryId: string
}>()

const root = ref<HTMLElement | null>()

const isMarketEligible = computed(() => {
  return [
    MarketCountryCode.GB,
    MarketCountryCode.DE,
    MarketCountryCode.ES,
  ].includes(countryCode)
})

const isExperimentValid = computed(() => {
  return (
    experiments['experiment.mobilePlanFakeDoor'] ===
      'withBackMarketMobilePlan' ||
    experiments['experiment.mobilePlanFakeDoor'] ===
      'withExternalTelcoMobilePlan'
  )
})

const isSmartphones = computed(() => {
  return props.categoryId === '2'
})

const shouldDisplayBackMarketMobilePlan = computed(() => {
  return (
    experiments['experiment.mobilePlanFakeDoor'] === 'withBackMarketMobilePlan'
  )
})

const { stop } = useIntersectionObserver(root, ([{ isIntersecting }]) => {
  if (isIntersecting) {
    tracking.trackProductBlockImpression({
      block_name: 'mobile_plan_step',
      product_model: props.trackingModel,
    })
  }
})

onUnmounted(() => {
  stop()
})
</script>
